@import '../../scss/mixin';

.intro {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  row-gap: size(15);
  min-height: calc(100vh - 100px);
  background: var(--llm-color-background);
  color: var(--llm-color-foreground);
}

.container {
  max-width: 860px;
  padding: 8px;
}

.content {
  display: flex;
  flex-direction: column;
  gap: 80px;
}

.head {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.title {
  font-weight: 400;
  font-size: 40px;
  line-height: 58px;
  letter-spacing: -2%;
  text-align: center;
  color: #28292B;
}

.prompt {
  pointer-events: auto;
  position: relative;
  z-index: 20;
  padding: 8px;
}

.inner {
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 12px;
  background: white;
  border-radius: 8px;
  box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.08);
}

.form {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 4px;
  width: 100%;
  transition: ease-in-out 350ms;
  transition-property: opacity;
}

.control {
  flex: 1 0 0;
  position: relative;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  padding: 4px;
  min-width: Min(450px, calc(100vw - 130px));
  min-height: 40px;
  border-radius: 100px;
  border: 1px solid #F2EFEB;
  overflow: visible;
  outline: 2px solid transparent;
  outline-offset: 0;

  &:has(:global(.-textarea.-textarea:focus)),
  &:has(:global(.-textarea.-textarea:focus-visible)) {
    outline-color: currentColor;
  }

  :global(.llm__busyIndicator) {
    display: none;
    position: absolute;
    left: 50px;
    top: 50%;
    margin: -16px 0 0 0;
    pointer-events: none;

    &::before {
      background: var(--llm-input-accent);
      opacity: 0.4;
    }

    &>span {

      &::before,
      &::after {
        opacity: 0.4;
        background: var(--llm-input-accent);
      }
    }
  }

  &.streaming {
    :global(.llm__busyIndicator) {
      display: block;
    }
  }
}

.actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: nowrap;
  gap: 12px;
  width: 100%;
}

.left,
.right {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 8px;
}

.right {
  justify-content: flex-end;
}
